import AppointmentContent from './AppointmentContent';


const Appointment = () => {
  return <AppointmentContent />;
};

export default Appointment;
